import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RoleBasedRedirect = () => {
  const user = useSelector((state) => state.auth.user);

  // Redirect based on user role
  if (user?.role === 'technician') {
    return <Navigate to="/job-board" replace />;
  }

  // Default for admin and other roles
  return <Navigate to="/booking" replace />;
};

export default RoleBasedRedirect;
